import { useState } from 'react';

type ApplicationData = {
  clientPolicyApplicationId: string;
  policyApplicationFormId?: string;
  stepType: PolicyApplicationStepType;
  status: 'completed' | 'not_started' | 'in_progress' | 'skipped' | 'blocked';
  submissionData: PolicyFormSubmissionData;
  visitedSubsections?: string[];
  submissionDateTime?: Date;
  stateOfResidenceAbbreviation: string | undefined;
};

export const usePreviousApplicationPreview = (
  previousApplicationData: ApplicationData[],
  state: any,
  actions: any,
) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedApplicationData, setSelectedApplicationData] = useState<ApplicationData | null>(
    null,
  );

  const handleSelectApplication = (
    selectedApplicationId: string,
    selectedApplicationFormId: string,
  ) => {
    const app = previousApplicationData.find(
      a =>
        a.clientPolicyApplicationId === selectedApplicationId &&
        a.policyApplicationFormId === selectedApplicationFormId,
    );
    setSelectedApplicationData(app ?? null);
  };

  const handleAcceptApplicationPrefil = () => {
    if (!selectedApplicationData) return;

    const submissionData = {
      ...selectedApplicationData.submissionData,
      ...state.formData,
    };

    const visitedSubsections = [
      ...new Set([
        ...(selectedApplicationData.visitedSubsections || []),
        ...state.visitedSubsections,
      ]),
    ];

    actions.initialize(submissionData, visitedSubsections);
    setOpenModal(false);
  };

  return {
    openModal,
    setOpenModal,
    selectedApplicationData,
    handleSelectApplication,
    handleAcceptApplicationPrefil,
  };
};